(() => {
  if (customElements.get('sticky-add-to-cart')) {
    return;
  }

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      
      this.sectionId = this.dataset.sectionId;
      this.stickyBar = this;
      this.mainProductForm = document.querySelector(`#ProductForm-${this.sectionId}`);
      this.mainProductSelector = document.querySelector(`#ProductSelector-${this.sectionId} product-selector`);
      this.stickyForm = this.querySelector('product-form[data-sticky-form]');
      this.stickyPrice = document.querySelector(`#StickyPrice-${this.sectionId}`);
      this.mainPrice = document.querySelector(`#Product-Price-${this.sectionId}`);
      this.mainAddToCartButton = document.querySelector('.button.product-selector__submit.no-js-hidden.button--filled.button--normalcase');
      this.bundleAddToCartButton = document.querySelector('.button.bundle-selector__submit');
      this.quantityAddToCartButton = document.querySelector('.button.quantity-bundle__submit');
      this.stickyAddToCartButton = this.querySelector('.sticky-add-to-cart__submit');
      
      this.isVisible = false;
      this.scrollThreshold = 300;
      this.isMobile = false;
      this.intersectionObserver = null;
      this.footerObserver = null;
      this.isFooterVisible = false;
      
      // Cache frequently used selectors
      this.cachedElements = new Map();
      this.updateTimeout = null;
      
      this.init();
    }

    init() {
      this.checkIfMobile();
      this.bindEvents();
      this.setupVisibilityLogic();
      this.syncVariants();
      this.handleScroll();
      // Initialize button prices
      this.updateButtonPrices();
    }

    updateButtonPrices() {
      const currentVariant = this.getCurrentVariant();
      if (currentVariant) {
        this.#updateButtonPriceSpans(currentVariant);
      }
    }

    getCurrentVariant() {
      try {
        const variantsScript = this.mainProductSelector?.querySelector('[type="application/json"]');
        if (!variantsScript) return null;
        
        const variants = JSON.parse(variantsScript.textContent || '[]');
        const currentVariantId = this.mainProductSelector?.querySelector('[name="id"]')?.value;
        
        return variants.find(variant => variant.id.toString() === currentVariantId);
      } catch (error) {
        console.error('Error getting current variant:', error);
        return null;
      }
    }

    #updateButtonPriceSpans(variant) {
      if (!variant) return;
      
      const formattedPrice = this.#formatPrice(variant.price);
      const isOutOfStock = !variant.available;
      
      // Update main button price span
      const mainButtonPriceSpan = this.mainAddToCartButton?.querySelector('.button__price');
      if (mainButtonPriceSpan) {
        if (isOutOfStock) {
          mainButtonPriceSpan.style.display = 'none';
        } else {
          mainButtonPriceSpan.style.display = '';
          mainButtonPriceSpan.textContent = ` - ${formattedPrice}`;
        }
      }
      
      // Update sticky button price span
      const stickyButtonPriceSpan = this.stickyAddToCartButton?.querySelector('.button__price');
      if (stickyButtonPriceSpan) {
        if (isOutOfStock) {
          stickyButtonPriceSpan.style.display = 'none';
        } else {
          stickyButtonPriceSpan.style.display = '';
          stickyButtonPriceSpan.textContent = ` - ${formattedPrice}`;
        }
      }
      
      // Update button text and disabled state
      this.#updateButtonStates(variant, isOutOfStock);
    }

    #updateButtonStates(variant, isOutOfStock) {
      // Update main button
      if (this.mainAddToCartButton) {
        const mainButtonText = this.mainAddToCartButton.childNodes[0];
        if (mainButtonText && mainButtonText.nodeType === Node.TEXT_NODE) {
          if (isOutOfStock) {
            mainButtonText.textContent = 'Sold Out';
            this.mainAddToCartButton.disabled = true;
          } else {
            mainButtonText.textContent = 'Add to Cart';
            this.mainAddToCartButton.disabled = false;
          }
        }
      }
      
      // Update sticky button
      if (this.stickyAddToCartButton) {
        const stickyButtonText = this.stickyAddToCartButton.childNodes[0];
        if (stickyButtonText && stickyButtonText.nodeType === Node.TEXT_NODE) {
          if (isOutOfStock) {
            stickyButtonText.textContent = 'Sold Out';
            this.stickyAddToCartButton.disabled = true;
          } else {
            stickyButtonText.textContent = 'Add to Cart';
            this.stickyAddToCartButton.disabled = false;
          }
        }
      }
    }

    #formatPrice(priceInCents) {
      // Use the shop's currency formatting if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(priceInCents);
      }
      
      // Fallback currency formatting - update currency as needed
      const price = priceInCents / 100;
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: `${window.Shopify.currency.active}`
      }).format(price);
    }

    checkIfMobile() {
      this.isMobile = window.innerWidth < 990;
    }

    setupVisibilityLogic() {
      // Set up footer observer
      this.setupFooterObserver();
      
      if (this.isMobile && this.mainAddToCartButton && 'IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const isButtonVisible = entry.isIntersecting;
            const buttonRect = this.mainAddToCartButton.getBoundingClientRect();
            const buttonTopPosition = buttonRect.top + window.scrollY;
            const currentScrollY = window.scrollY;
            const hasScrolledPastButton = currentScrollY > buttonTopPosition;

            const shouldShowSticky = !isButtonVisible && hasScrolledPastButton && !this.isFooterVisible;
            
            if (shouldShowSticky !== this.isVisible) {
              this.isVisible = shouldShowSticky;
              this.classList.toggle('is-visible', shouldShowSticky);
            }
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });

        this.intersectionObserver.observe(this.mainAddToCartButton);
      } else if(this.isMobile && this.bundleAddToCartButton && 'IntersectionObserver' in window){
                this.intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                  const isButtonVisible = entry.isIntersecting;
                  const buttonRect = this.bundleAddToCartButton.getBoundingClientRect();
                  const buttonTopPosition = buttonRect.top + window.scrollY;
                  const currentScrollY = window.scrollY;
                  const hasScrolledPastButton = currentScrollY > buttonTopPosition;
                  const shouldShowSticky = !isButtonVisible && hasScrolledPastButton && !this.isFooterVisible;
                  if (shouldShowSticky !== this.isVisible) {
                    this.isVisible = shouldShowSticky;
                    this.classList.toggle('is-visible', shouldShowSticky);
                  }
                });
              }, {
                root: null,
                rootMargin: '0px',
                threshold: 0
              });

              this.intersectionObserver.observe(this.bundleAddToCartButton);
      
      } else if(this.isMobile && this.quantityAddToCartButton && 'IntersectionObserver' in window){
                this.intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                  const isButtonVisible = entry.isIntersecting;
                  const buttonRect = this.quantityAddToCartButton.getBoundingClientRect();
                  const buttonTopPosition = buttonRect.top + window.scrollY;
                  const currentScrollY = window.scrollY;
                  const hasScrolledPastButton = currentScrollY > buttonTopPosition;
                  const shouldShowSticky = !isButtonVisible && hasScrolledPastButton && !this.isFooterVisible;
                  console.log(currentScrollY)
                  console.log(buttonTopPosition)
                  console.log(shouldShowSticky)
                  console.log(!isButtonVisible)
                  console.log(!this.isFooterVisible)
                  if (shouldShowSticky !== this.isVisible) {
                    this.isVisible = shouldShowSticky;
                    this.classList.toggle('is-visible', shouldShowSticky);
                  }
                });
              }, {
                root: null,
                rootMargin: '0px',
                threshold: 0
              });

              this.intersectionObserver.observe(this.quantityAddToCartButton);
        }
              else {
        window.addEventListener('scroll', this.#throttle(this.handleScroll.bind(this), 100));
      }
    }

    bindEvents() {
      window.addEventListener('resize', this.#throttle(() => {
        const wasMobile = this.isMobile;
        this.checkIfMobile();
        
        if (wasMobile !== this.isMobile) {
          this.teardownVisibilityLogic();
          this.setupVisibilityLogic();
        }
      }, 250));
      
      if (this.mainProductSelector) {
        this.mainProductSelector.addEventListener('change', this.syncVariants.bind(this));
        // Listen for variant changes to update button prices
        this.mainProductSelector.addEventListener('change', () => {
          setTimeout(() => this.updateButtonPrices(), 100);
        });
      }
      
      this.addEventListener('change', this.handleStickyVariantChange.bind(this));
      
      if (this.stickyForm) {
        this.stickyForm.addEventListener('submit', this.handleStickySubmit.bind(this));
      }
      
      // Listen for global variant change events
      document.addEventListener('variant:change', () => {
        setTimeout(() => this.updateButtonPrices(), 100);
      });
    }

    setupFooterObserver() {
      if ('IntersectionObserver' in window) {
        const footer = document.querySelector('footer, .footer, #footer');
        if (footer) {
          this.footerObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              this.isFooterVisible = entry.isIntersecting;
              
              // If footer becomes visible, hide sticky bar immediately
              if (this.isFooterVisible && this.isVisible) {
                this.isVisible = false;
                this.classList.remove('is-visible');
              } else{
                this.isVisible = true;
                this.classList.add('is-visible');
              }
            });
          }, {
            root: null,
            rootMargin: '50px 0px 0px 0px', // Start hiding 50px before footer
            threshold: 0
          });

          this.footerObserver.observe(footer);
        }
      }
    }

    teardownVisibilityLogic() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      
      if (this.footerObserver) {
        this.footerObserver.disconnect();
        this.footerObserver = null;
      }
    }

    handleScroll() {
      if (!this.isMobile || !this.mainAddToCartButton || !('IntersectionObserver' in window)) {
        const shouldShow = window.scrollY > this.scrollThreshold && !this.isFooterVisible;
        if (shouldShow !== this.isVisible) {
          this.isVisible = shouldShow;
          this.classList.toggle('is-visible', shouldShow);
        }
      }
      if (!this.isMobile || !this.bundleAddToCartButton || !('IntersectionObserver' in window)) {
        const shouldShow = window.scrollY > this.scrollThreshold && !this.isFooterVisible;
        if (shouldShow !== this.isVisible) {
          this.isVisible = shouldShow;
          this.classList.toggle('is-visible', shouldShow);
        }
      }
      if (!this.isMobile || !this.quantityAddToCartButton || !('IntersectionObserver' in window)) {
        const shouldShow = window.scrollY > this.scrollThreshold && !this.isFooterVisible;
        if (shouldShow !== this.isVisible) {
          this.isVisible = shouldShow;
          this.classList.toggle('is-visible', shouldShow);
        }
      }
    }

    syncVariants() {
      const mainVariantId = this.mainProductSelector?.querySelector('[name="id"]')?.value;
      const stickyVariantInput = this.querySelector('[data-sticky-variant-id]');
      
      if (mainVariantId && stickyVariantInput) {
        stickyVariantInput.value = mainVariantId;
      }

      const mainRadios = this.mainProductSelector?.querySelectorAll('input[type="radio"][name*="options"]') || [];
      const mainSelects = this.mainProductSelector?.querySelectorAll('select[name*="options"], dropdown-input select[name*="options"]') || [];
      const stickySelects = this.querySelectorAll('dropdown-input select, .sticky-variant-select select');
      
      mainRadios.forEach((mainRadio) => {
        if (mainRadio.checked) {
          const optionName = mainRadio.name;
          const optionValue = mainRadio.value;
          
          const matchingStickySelect = Array.from(stickySelects).find(select => select.name === optionName);
          if (matchingStickySelect && matchingStickySelect.value !== optionValue) {
            matchingStickySelect.value = optionValue;
          }
        }
      });
      
      mainSelects.forEach((mainSelect, index) => {
        const stickySelect = Array.from(stickySelects).find(select => select.name === mainSelect.name);
        if (stickySelect && mainSelect.value !== stickySelect.value) {
          stickySelect.value = mainSelect.value;
        }
      });

      const mainQuantity = this.mainProductForm?.querySelector('[name="quantity"]')?.value || 1;
      const stickyQuantity = this.querySelector('[name="quantity"]');
      
      if (stickyQuantity) {
        stickyQuantity.value = mainQuantity;
      }

      this.updateStickyPrice();
      this.updateButtonPrices(); // Update button prices when syncing
    }

    handleStickyVariantChange(event) {
      if (event.target.matches('dropdown-input select') || event.target.matches('.sticky-variant-select select')) {
        this.updateVariantFromSticky();
      }
    }

    updateVariantFromSticky() {
      try {
        const stickySelects = this.querySelectorAll('dropdown-input select, .sticky-variant-select select');
        const selectedOptions = Array.from(stickySelects).map(select => ({
          name: select.name,
          value: select.value
        }));

        const variantsScript = this.mainProductSelector?.querySelector('[type="application/json"]');
        
        if (!variantsScript) {
          console.warn('Variants script not found');
          return;
        }
        
        const variants = JSON.parse(variantsScript.textContent || '[]');
        
        const matchedVariant = variants.find(variant => {
          return selectedOptions.every((option, index) => {
            return variant[`option${index + 1}`] === option.value;
          });
        });

        if (matchedVariant) {
          // Check if variant is available
          if (!matchedVariant.available) {
            this.#handleOutOfStockVariant(matchedVariant);
            return;
          }
          
          const mainRadios = this.mainProductSelector?.querySelectorAll('input[type="radio"][name*="options"]') || [];
          const mainSelects = this.mainProductSelector?.querySelectorAll('select[name*="options"], dropdown-input select[name*="options"]') || [];
          
          mainRadios.forEach((radio, index) => {
            const matchingOption = selectedOptions.find(opt => opt.name === radio.name);
            const shouldCheck = radio.value === matchingOption?.value;
            radio.checked = shouldCheck;
          });
          
          mainSelects.forEach((select, index) => {
            const matchingOption = selectedOptions.find(opt => opt.name === select.name);
            if (matchingOption) {
              select.value = matchingOption.value;
            }
          });

          const mainVariantInput = this.mainProductSelector?.querySelector('[name="id"]');
          if (mainVariantInput) {
            mainVariantInput.value = matchedVariant.id;
          }

          this.#triggerVariantChangeEvents();
          this.#updateMainProductMedia(matchedVariant);
          this.#updateMainProductPrice(matchedVariant);
          this.#updateButtonPriceSpans(matchedVariant); // Update button prices

          const stickyVariantInput = this.querySelector('[data-sticky-variant-id]');
          if (stickyVariantInput) {
            stickyVariantInput.value = matchedVariant.id;
          }

          setTimeout(() => this.updateStickyPrice(), 100);
          setTimeout(() => this.updateStickyPrice(), 300);
          setTimeout(() => this.updateStickyPrice(), 500);
        } else {
          console.warn('No matching variant found for selected options');
        }
      } catch (error) {
        console.error('Error updating variant from sticky:', error);
      }
    }

    updateStickyPrice() {
      // Clear existing timeout to avoid multiple rapid updates
      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout);
      }
      
      this.updateTimeout = setTimeout(() => {
        if (this.mainPrice && this.stickyPrice) {
          if (this.mainPrice.innerHTML !== this.stickyPrice.innerHTML) {
            this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
          }
        }
        this.updateTimeout = null;
      }, 150); // Single timeout instead of multiple
    }

    handleStickySubmit(event) {
      event.preventDefault();
      const stickyQuantity = this.querySelector('[name="quantity"]')?.value || 1;
      const mainQuantity = this.mainProductForm?.querySelector('[name="quantity"]');
      
      if (mainQuantity) {
        mainQuantity.value = stickyQuantity;
      }

      const stickyVariantId = this.querySelector('[data-sticky-variant-id]')?.value;
      const mainVariantInput = this.mainProductForm?.querySelector('[name="id"]');
      
      if (stickyVariantId && mainVariantInput) {
        mainVariantInput.value = stickyVariantId;
      }

      if (this.mainProductForm) {
        const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        this.mainProductForm.dispatchEvent(submitEvent);
      }
    }

    disconnectedCallback() {
      this.teardownVisibilityLogic();
    }

    #throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      }
    }

    #triggerVariantChangeEvents() {
      if (this.mainProductSelector) {
        this.mainProductSelector.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.mainProductForm) {
        this.mainProductForm.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const variantChangeEvent = new CustomEvent('variant:change', {
        bubbles: true,
        detail: { source: 'sticky-add-to-cart' }
      });
      document.dispatchEvent(variantChangeEvent);
    }

    #updateMainProductMedia(variant) {
      if (variant.featured_media && variant.featured_media.id) {
        const targetMediaElement = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        
        if (targetMediaElement) {
          const swiperContainer = document.querySelector('.product__media .swiper-container, .product__media .swiper');
          
          if (swiperContainer) {
            let swiperInstance = swiperContainer.swiper;
            
            if (!swiperInstance && window.Swiper) {
              swiperInstance = window.Swiper.get?.(swiperContainer);
            }
            
            const targetIndex = parseInt(targetMediaElement.dataset.index);
            
            if (swiperInstance && !isNaN(targetIndex)) {
              swiperInstance.slideTo(targetIndex);
            } else {
              this.#navigateToSlide(swiperContainer, targetIndex);
            }
          } else {
            this.#updateMediaClasses(targetMediaElement);
          }
        }
      }
      
      this.#updateStickyImage(variant);
    }

    #updateStickyImage(variant) {
      const stickyImage = this.querySelector('.sticky-add-to-cart__image img');
      
      if (stickyImage && variant.featured_media) {
        // Add loading class for better UX
        stickyImage.classList.add('loading');
        
        let imageUrl = variant.featured_media.preview_image?.src;
        
        if (!imageUrl && variant.featured_image) {
          imageUrl = variant.featured_image.src;
        }
        
        if (!imageUrl) {
          const targetMediaElement = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          const mediaImage = targetMediaElement?.querySelector('img');
          if (mediaImage) {
            imageUrl = mediaImage.src;
          }
        }
        
        if (imageUrl) {
          if (imageUrl.startsWith('//')) {
            imageUrl = 'https:' + imageUrl;
          }
          
          // Create a new image to preload and handle errors
          const newImage = new Image();
          
          newImage.onload = () => {
            stickyImage.src = imageUrl;
            
            // Better srcset without aggressive cache busting
            const baseUrl = imageUrl.split('?')[0];
            const version = imageUrl.includes('?v=') ? imageUrl.split('?v=')[1].split('&')[0] : 'auto';
            const newSrcset = `${baseUrl}?v=${version}&width=100 100w, ${baseUrl}?v=${version}&width=200 200w`;
            stickyImage.srcset = newSrcset;
            
            stickyImage.alt = variant.name || variant.title || 'Product variant image';
            stickyImage.classList.remove('loading');
            
            // Announce change to screen readers
            this.#announceVariantChange(variant);
          };
          
          newImage.onerror = () => {
            stickyImage.classList.remove('loading');
            console.warn('Failed to load variant image:', imageUrl);
          };
          
          newImage.src = imageUrl;
        }
      }
    }

    #navigateToSlide(swiperContainer, targetIndex) {
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      const currentActiveSlide = swiperContainer.querySelector('.swiper-slide-active');
      const currentIndex = currentActiveSlide ? Array.from(slides).indexOf(currentActiveSlide) : 0;
      
      if (currentIndex !== targetIndex) {
        const nextBtn = swiperContainer.querySelector('.swiper-button-next');
        const prevBtn = swiperContainer.querySelector('.swiper-button-prev');
        
        if (nextBtn && prevBtn) {
          const steps = Math.abs(targetIndex - currentIndex);
          const button = targetIndex > currentIndex ? nextBtn : prevBtn;
          
          for (let i = 0; i < steps; i++) {
            setTimeout(() => {
              button.click();
            }, i * 200);
          }
        } else {
          this.#activateSlide(slides, targetIndex);
        }
      }
    }

    #activateSlide(slides, targetIndex) {
      slides.forEach((slide, index) => {
        slide.classList.remove('swiper-slide-active', 'swiper-slide-visible', 'swiper-slide-fully-visible');
        if (index === targetIndex) {
          slide.classList.add('swiper-slide-active', 'swiper-slide-visible', 'swiper-slide-fully-visible');
        }
      });
      
      const wrapper = slides[0]?.parentElement;
      if (wrapper && wrapper.classList.contains('swiper-wrapper')) {
        const slideWidth = slides[0]?.offsetWidth || 0;
        const offset = -targetIndex * slideWidth;
        wrapper.style.transform = `translate3d(${offset}px, 0px, 0px)`;
      }
    }

    #updateMediaClasses(targetMediaElement) {
      const allMedia = document.querySelectorAll('.product__media .media, .product__media .swiper-slide');
      allMedia.forEach(el => el.classList.remove('media--active', 'is-active', 'active'));
      
      targetMediaElement.classList.add('media--active', 'is-active', 'active');
      const wrapper = targetMediaElement.closest('.media');
      if (wrapper) {
        wrapper.classList.add('media--active', 'is-active', 'active');
      }
    }

    #updateMainProductPrice(variant) {
      if (variant.price !== undefined) {
        const priceUpdateEvent = new CustomEvent('variant:price:update', {
          bubbles: true,
          detail: { variant, source: 'sticky-add-to-cart' }
        });
        document.dispatchEvent(priceUpdateEvent);
      }

      const productForm = document.querySelector('product-form');
      if (productForm && typeof productForm.updatePrice === 'function') {
        productForm.updatePrice();
      }

      if (this.mainProductSelector && typeof this.mainProductSelector.updatePrice === 'function') {
        this.mainProductSelector.updatePrice();
      }

      const mainVariantInput = this.mainProductSelector?.querySelector('[name="id"]');
      if (mainVariantInput) {
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        mainVariantInput.dispatchEvent(new Event('input', { bubbles: true }));
        
        if (this.mainProductSelector) {
          this.mainProductSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // Accessibility improvement
    #announceVariantChange(variant) {
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      announcement.textContent = `Variant changed to ${variant.title || 'selected option'}`;
      
      document.body.appendChild(announcement);
      
      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    }

    // Handle out of stock variants
    #handleOutOfStockVariant(variant) {
      this.#updateButtonPriceSpans(variant); // This will handle the sold out state
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
})(); 